module.exports = __webpack_public_path__ + "img/forklift__distribution_warehouse_equipment_loader-128.5ec614ec.png";